import { Route, Routes } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

import UnauthorizedView from "../UI/UnauthorizedView";

import ECRCommentsTable from "./ECRCommentsTable";
import EcrDetails from "./EcrDetails/EcrDetails.screen";
import EcrOverview from "./EcrOverview/EcrOverview.screen";

export default function ECRManager() {
  const { permissions } = useAuth();

  if (
    !permissions?.role_permissions?.find(
      (permission) => permission.area === "ECR Comments",
    )?.read
  ) {
    <UnauthorizedView />;
  }

  return (
    <Routes>
      <Route path="/" element={<EcrOverview />} />
      {/* NOTE: Is this route even being used? */}
      <Route path="/:vid" element={<ECRCommentsTable />} />
      <Route path="details/:id" element={<EcrDetails />} />
    </Routes>
  );
}
